import { DataFieldWithOptionsAndSingleLocation } from './DataField';
import { SequelizeTimestamps } from './Sequelize';
import { UserShort } from './User';

export interface Department extends SequelizeTimestamps {
  id: number;
  name: string;
  adAppRole: string;
  contactID: string;
  orderId?: any;
  assignmentType?: string | undefined;
  lastUsedContactID?: string | undefined;
  weightageList?: string | [];
  stakeholderVariableId?: string | undefined;
  departmentDisplayOrderId?: number | null;
}

export interface DepartmentExtended extends Department {
  contact: UserShort;
  stakeholderVariable?: UserShort;
  departmentDataFields: DataFieldWithOptionsAndSingleLocation[];
}

export interface CreateDepartmentBody {
  name: string;
  adAppRole: string;
  contactID?: string | undefined;
  assignmentType?: string;
  lastUsedContactID?: string;
  weightageList?: string | [];
  stakeholderVariableId?: string;
  departmentDisplayOrderId?: number | null;
}
export interface UpdateDepartmentBody {
  name?: string;
  adAppRole?: string;
  contactID?: string;
  assignmentType?: string;
  lastUsedContactID?: string;
  weightageList?: string | [];
  stakeholderVariableId?: string;
  departmentDisplayOrderId?: number | null;
}
export interface DepartmentOrderUpdate {
  orderId?: any;
  id?: any;
}
export type reOrderDepartmentBody = {
  payload: DepartmentOrderUpdate[];
}
export enum deptBusiness {
  basedOnBusinessUnit = "Based on Business unit"
}

export enum DepartmentAdminActions {
  createDepartmentTemplate = 'createDepartmentTemplate',
  updateDepartmentTemplate = 'updateDepartmentTemplate',
  deleteDepartmentTemplate = 'deleteDepartmentTemplate'
}
